import { Product, Site } from './';
import { Vehicle } from './Vehicle';

export interface Relocation {
    id: number;
    creationDate: string;
    destination: Site;
    externalData: string;
    finish: string;
    fixed: boolean;
    name: string;
    owner: string;
    packId: number;
    product: Product;
    quantity: number;
    sentQuantity: number;
    source: Site;
    start: string;
    weight: number;
    currentLocationCommentId?: number;
    currentLocationComment: string;
    operationsCraneId?: number;
    operationsCrane: string;
    placementId?: number;
    placement: string;
    startTransshipmentTime?: string;
    finishTransshipmentTime?: string;
    timeDuration?: string;
    important: boolean;
    customWeightFactor?: number;
    customDisplayDenominator?: number;
    resource: Vehicle;
    distance?: number;
}

export enum RelocationsType {
    FIXED = 'fixed'
}

export enum RelocationsDirection {
    INCOMING = 'incoming'
}
